/**
 * SquareCard component.
 */
import Card from '@shared/types/props/card';
import Container from '@components/atoms/container/squareItemContainer';
import Event from '@shared/classes/event';
import Image from '@components/atoms/images/squareImage';
import MainContext from '@shared/components/utils/context/mainContext';
import { memo, useContext } from 'react';

function SquareCard({ focused, hide, item, onClick }: Card) {
  const { hoverAsset } = useContext(MainContext);
  return (
    <Container
      id='squareCardContainer'
      focused={focused}
      hide={hide}
      onClick={onClick}
      onMouseEnter={() => hoverAsset(item)}
    >
      <Image src={(item as Event)?.channel?.logo} />
    </Container>
  );
}

export default memo(SquareCard);
